import runSsrSafely from '@utils/ssr/runSsrSafely';
import fetchTemplatePage from '@utils/ssr/fetchTemplatePage';

export default function ssrFetch(ctx) {
    const options = ctx.timeout ? {timeout: ctx.timeout} : {};
    return runSsrSafely(fetchTemplatePage({...ctx, options}));
}
